import { Type } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsNumber, IsString, IsUrl, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base';
import { FileId } from '../../types';
import { UserCreatedByPopulateDto } from '../users/populate/user-created-by-populate.dto';
import { FilePurpose } from './file-purpose.enum';

export class FileSummaryDto extends BaseDto<FileId> {
  @IsString()
  @IsNotEmpty()
  filename!: string;

  @IsString()
  @IsNotEmpty()
  mimeType!: string;

  @IsNumber()
  @IsNotEmpty()
  size!: number;

  @IsUrl()
  @IsNotEmpty()
  url!: string;

  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsNotEmpty()
  uploadedBy!: UserCreatedByPopulateDto;

  @IsEnum(FilePurpose)
  @IsNotEmpty()
  purpose!: FilePurpose;
}
